var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconDownloadComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-download ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33329 8.05719L7.33329 2.33333C7.33329 2.14924 7.48253 2 7.66663 2H8.33329C8.51739 2 8.66663 2.14924 8.66663 2.33333V8.05719L9.95952 6.7643C10.0897 6.63412 10.3007 6.63412 10.4309 6.7643L10.9023 7.2357C11.0325 7.36588 11.0325 7.57693 10.9023 7.70711L8.47136 10.1381C8.21101 10.3984 7.7889 10.3984 7.52855 10.1381L5.09759 7.70711C4.96742 7.57693 4.96742 7.36588 5.09759 7.2357L5.56899 6.7643C5.69917 6.63412 5.91022 6.63412 6.0404 6.7643L7.33329 8.05719ZM1.66663 12L1.66663 9C1.66663 8.81591 1.81586 8.66667 1.99996 8.66667H2.66663C2.85072 8.66667 2.99996 8.81591 2.99996 9L2.99996 12C2.99996 12.3682 3.29844 12.6667 3.66663 12.6667L12.3333 12.6667C12.7015 12.6667 13 12.3682 13 12V9C13 8.81591 13.1492 8.66667 13.3333 8.66667H14C14.1841 8.66667 14.3333 8.81591 14.3333 9V12C14.3333 13.1046 13.4379 14 12.3333 14L3.66663 14C2.56206 14 1.66663 13.1046 1.66663 12Z",
    fillOpacity: "1"
  }));
}
var IconDownload = /*#__PURE__*/React.forwardRef(IconDownloadComponent);
export default IconDownload;